import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;

  > label {
    font-weight: bold;
    margin-bottom: 5px;
  }

  > span {
    margin-top: 2px;

    font-size: 12px;
    color: var(--primary);
    /* display: none; */
  }
`;
